module.exports = __webpack_public_path__ + "static/media/10.2c13336a.png";